
export default function PricingSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Nos Formules d'Accompagnement
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choisissez la formule qui correspond le mieux à vos besoins et votre budget
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Formule Découverte */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Découverte</h3>
              <div className="text-3xl font-bold text-blue-600 mb-1">75€</div>
              <p className="text-gray-600">par séance</p>
            </div>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">1 séance de 60 minutes</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Bilan personnalisé</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Plan d'action initial</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Support par email</span>
              </li>
            </ul>
            
            <button className="w-full bg-gray-100 text-gray-800 py-3 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap">
              Choisir cette formule
            </button>
          </div>
          
          {/* Formule Accompagnement */}
          <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-blue-500 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-blue-500 text-white px-4 py-1 rounded-full text-sm font-medium">
                Populaire
              </span>
            </div>
            
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Accompagnement</h3>
              <div className="text-3xl font-bold text-blue-600 mb-1">280€</div>
              <p className="text-gray-600">4 séances (70€/séance)</p>
            </div>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">4 séances de 60 minutes</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Suivi personnalisé</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Outils et exercices</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Support illimité par email</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Bilan de progression</span>
              </li>
            </ul>
            
            <button className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
              Choisir cette formule
            </button>
          </div>
          
          {/* Formule Transformation */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Transformation</h3>
              <div className="text-3xl font-bold text-blue-600 mb-1">520€</div>
              <p className="text-gray-600">8 séances (65€/séance)</p>
            </div>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">8 séances de 60 minutes</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Programme complet</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Ressources exclusives</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Support prioritaire</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-3"></i>
                <span className="text-gray-700">Séance de suivi gratuite</span>
              </li>
            </ul>
            
            <button className="w-full bg-gray-100 text-gray-800 py-3 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap">
              Choisir cette formule
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
